import React from 'react'
import { Link } from 'react-router-dom';
import Blogimage01 from '../../../assets/images/blog/blog-grid-2-imag-1.jpg';
import Blogimage02 from '../../../assets/images/blog/blog-grid-2-imag-2.jpg';
import Blogimage03 from '../../../assets/images/blog/blog-grid-2-imag-3.jpg';
import Blogimage04 from '../../../assets/images/blog/blog-grid-2-imag-4.jpg';
import Blogimage05 from '../../../assets/images/blog/blog-grid-2-imag-5.jpg';
import Blogimage06 from '../../../assets/images/blog/blog-grid-2-imag-6.jpg';
import Blogimage07 from '../../../assets/images/blog/blog-grid-2-imag-7.jpg';
import Blogimage08 from '../../../assets/images/blog/blog-grid-2-imag-8.jpg';
import Blogimage09 from '../../../assets/images/blog/blog-grid-2-imag-9.jpg';

const Teamdetail = () => {
    return (
        <div className="blog-list-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage01}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Deni</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 06 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            The Benefits of Quick Loan Approvals for Small Businesses
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage02}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Elei</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 15 Aug 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            Innovative Financing Solutions for Modern Startups
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage03}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Jhon</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 20 Jun 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            Key Financial Metrics Lenders Look for in Your Loan
                                            Application
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage04}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Martin</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 10 May 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            Key Financial Metrics Lenders Look for in Your Loan
                                            Application
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage05}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Chris</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            Key Financial Metrics Lenders Look for in Your Loan
                                            Application
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage06}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Deni</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 25 Dec 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            The Impact of Credit Scores on Your Loan Application
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage07}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Juhi</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 05 Jan 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            Key Financial Metrics Lenders Look for in Your Loan
                                            Application
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage08}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Vicky</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            How loanlift Supports Business Growth Through Tailored Loans
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        {" "}
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-block">
                            <div className="blog-list-item-two">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Blogimage09}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Deni</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 25 Dec 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h5>
                                        <Link to="/Blogdetails">
                                            The Role of Collateral in Securing a Business Loan
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="blog-block">
                        <ul className="pagination">
                            <li className="active">
                                <Link to="#">1</Link>
                            </li>
                            <li>
                                <Link to="#">2</Link>
                            </li>
                            <li>
                                <Link to="#">3</Link>
                            </li>
                            <li>
                                <Link to="#">4</Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fa-solid fa-angles-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Teamdetail;